<div class="page-timeout">
  <app-header></app-header>
  <div class="page-timeout__content">
    <pichincha-spot-module
      spot-title="Tu sesión ha terminado"
      spot-description="Por tu seguridad, establecemos un tiempo límite de sesión."
    ></pichincha-spot-module>
    <pichincha-typography
      variant="prelo"
      weight="400"
      size="16px"
      line-height="24px"
      color="bp-grayScale500"
      >No te preocupes, puedes volver a ingresar.</pichincha-typography
    >
    <br />
    <pichincha-button
      label="Iniciar sesión"
      size="large"
      (click)="handleRedirect()"
    ></pichincha-button>
  </div>
  <app-footer></app-footer>
</div>
